// @flow strict

import type {ApiUrl} from 'src/hooks/useApi';

// $FlowFixMe[nonstrict-import]
import * as api from 'src/utils/api-no-store';
// $FlowFixMe[nonstrict-import]
import {useResource, type ResourceState} from './useResource';


export function useNoStoreApi<T>(
  url?: ApiUrl,
  options?: {method: 'get' | 'post', onError?: (Error) => mixed},
): ResourceState<T> {
  let pathname;
  let query;
  let payload = undefined;
  if (typeof url === 'string') {
    pathname = url;
  } else if (url instanceof Object && options?.method !== 'post') {
    const searchParams = new URLSearchParams(url.query);
    query = searchParams.toString();
    pathname = `${url.pathname}?${searchParams.toString()}`;
  } else if (url instanceof Object && options?.method === 'post') {
    pathname = url.pathname;
    payload = url.query;
    query = JSON.stringify(payload);
  }

  return useResource(
    () => (url ? api[options?.method ?? 'get'](pathname, payload) : noGet()),
    {deps: [pathname, query], onError: options?.onError},
  );
}
export default useNoStoreApi;

// $FlowFixMe[incompatible-return]
const noGet = <T>(): T => Promise.resolve();
